import React, { useEffect, useState } from 'react'
import UsersManager from '../../managers/UsersManager'
import PermissionManager from '../../managers/PermissionManager'
import { Permission } from '../../os_definitions/OsPermissions'

interface P {
    permission: Permission
    children: React.ReactElement
}

const PermissionsWrapper = ({ permission, children }: P) => {
    const [canAccess, setCanAccess] = useState<boolean>(false)
    const currentUser = UsersManager.getCurrentUser()

    useEffect(() => {
        const checkPermission = async () => {
            const can = PermissionManager.hasPermission(permission, currentUser)
            setCanAccess(can)
        }
        checkPermission()
    }, [permission, currentUser])

    if (canAccess) return children
    else return null
}

export default PermissionsWrapper
